import React, { useState } from 'react';
import { Button, Form, Spinner, Alert } from 'react-bootstrap';
import { patch } from '../../../helpers/httpClient';
import { toast } from 'react-toastify';

function General({ website, onUpdated }) {
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    internal_domain: (website && website.internal_domain) || '',
    title: (website && website.title) || '',
    domain: (website && website.domain) || '',
    description: (website && website.description) || '',
    seoSettings: {
      showCookieConsent: website?.seoSettings?.showCookieConsent ?? false,
      googleAnalyticsId: website?.seoSettings?.googleAnalyticsId ?? '',
      jsonLDSettings: {
        profileType: website?.seoSettings?.jsonLDSettings?.profileType ?? 'individual',
      },
    },
  });

  if (!website) {
    return <Alert variant="warning">Website not found.</Alert>;
  }

  const save = async (e) => {
    e.preventDefault();
    if (!form.internal_domain.trim() || !form.title.trim()) {
      toast.error('Internal domain and title are required');
      return;
    }
    try {
      setSaving(true);
      const payload = {
        ...form,
        seoSettings: {
          ...form.seoSettings,
          googleAnalyticsId: form.seoSettings.googleAnalyticsId.trim() || null,
        },
      };
      const resp = await patch(`websites/${website.id}`, payload);
      const updated = resp?.website || { ...website, ...form };
      onUpdated?.(updated);
    } catch (e) {
      toast.error('Failed to save changes.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <Form onSubmit={save}>
        <Form.Group className="mb-3 form-row-horizontal" controlId="editInternalDomain">
          <Form.Label>Internal domain</Form.Label>
          <Form.Control
            type="text"
            value={form.internal_domain}
            onChange={(e) => setForm({ ...form, internal_domain: e.target.value })}
            placeholder="e.g. project-123"
          />
        </Form.Group>
        <Form.Group className="mb-3 form-row-horizontal" controlId="editTitle">
          <Form.Label>Title</Form.Label>
          <Form.Control
            type="text"
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
            placeholder="Marketing site"
          />
        </Form.Group>
        <Form.Group className="mb-3 form-row-horizontal" controlId="editDomain">
          <Form.Label>Domain</Form.Label>
          <Form.Control
            type="text"
            value={form.domain}
            onChange={(e) => setForm({ ...form, domain: e.target.value })}
            placeholder="Optional: www.example.com"
          />
        </Form.Group>
        <Form.Group className="mb-3 form-row-horizontal" controlId="editDescription">
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
            placeholder="Optional: brief description of the website"
          />
        </Form.Group>
        <hr />
        <h6 className="mb-3">SEO Settings</h6>
        <Form.Group className="mb-3 form-row-horizontal" controlId="editShowCookieConsent">
          <Form.Check
            type="checkbox"
            label="Show cookie consent"
            checked={form.seoSettings.showCookieConsent}
            onChange={(e) => setForm({ ...form, seoSettings: { ...form.seoSettings, showCookieConsent: e.target.checked } })}
          />
        </Form.Group>
        {form.seoSettings.showCookieConsent && (
          <Form.Group className="mb-3 form-row-horizontal" controlId="editGoogleAnalyticsId">
            <Form.Label>Google Analytics ID</Form.Label>
            <Form.Control
              type="text"
              value={form.seoSettings.googleAnalyticsId}
              onChange={(e) => setForm({ ...form, seoSettings: { ...form.seoSettings, googleAnalyticsId: e.target.value } })}
              placeholder="e.g. G-XXXXXXXXXX"
            />
          </Form.Group>
        )}
        <Form.Group className="mb-3 form-row-horizontal" controlId="editProfileType">
          <Form.Label>Profile type</Form.Label>
          <Form.Select
            value={form.seoSettings.jsonLDSettings.profileType}
            onChange={(e) => setForm({ ...form, seoSettings: { ...form.seoSettings, jsonLDSettings: { profileType: e.target.value } } })}
          >
            <option value="individual">Individual</option>
            <option value="organisation">Organisation</option>
          </Form.Select>
        </Form.Group>
        <div className="form-actions">
          <Button type="submit" className="primary-button" disabled={saving}>
            {saving ? (<><Spinner animation="border" size="sm" className="me-2" /> Saving...</>) : 'Save'}
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default General;
